<div style="padding: 24px;">
 <button mat-menu-item (click)="GetPdfDigitalForm()">{{'Generate PDF'}}</button>   
  <mat-card> 
    <ul *ngFor="let item of  FormSectionDetails" style="background-color: white;">
      
      <div style="display: flex; flex-direction: row;justify-content: flex-end;">
        <div>

      <span title="Move up"
      style="margin-right: 16px!important; cursor: pointer;"
      [class.button-hide]="item.GroupOrder==0?true:false"
      (click)="recalculateSortOrderUp(item.GroupOrder)">
      <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_upward</i>
  </span>
      </div>
        <div>
      <span title="Move down"
      [class.button-hide]="item.group_order==FormSectionDetails.length-1?true:false"
      (click)="recalculateSortOrderDown(item.GroupOrder)"
      style="margin-right: 16px!important;cursor: pointer;">
      <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_downward</i>
  </span>
    </div>
      </div>
      <div>
        <li 
        class="dropzone"
        draggable="true" 
        
        attr.id="{{item.GroupOrder}}"   
        style="border-style: solid; border-width: 1px;padding-top: 12px;
        padding-right: 12px;
        padding-bottom: 12px;
        padding-left: 12px;">
       

<div style="    display: flex; flex-direction: row;">
  <div 
  (dragover)="allowDrop($event)" style="display: flex; flex-direction: column;width: min-content;" class="dropzone_child">
    <div>
      <span class="component-type" style="font-size: 18px;"> <b> {{item.CategoryName}} </b>
      </span>
    </div>
    <div >
      <input matInput type='text' placeholder="Update Section Name" style="font-size: 14px;" [(ngModel)]="item.CategoryName" class="get-Input"
      (change)="GroupTypeNameChanged(item.CategoryId, item.CategoryName)">
    </div>
  </div> 



  <div  style="display: flex; flex-direction: column;margin-left: 240px; " class="dropzone_child">
    <div>
      <!-- <span class="component-type" style="font-size: 18px;"> <b> Include in Report Body </b>
      </span> -->
    </div>
    <div style="margin-top: 11px;">
      <span class="component-flag">
        <b>
          <!-- <mat-checkbox style="padding-right: 8px;"  [checked]="item?.IncludeInBody" (change)="toggleIncludeBody(item.QuestionCatId)"><span class="label-reportoption"
            >Include in Report Body</span>
          </mat-checkbox> -->
          <mat-checkbox style="padding-right: 8px;"  [checked]="item?.IncludeInBody" (change)="toggleIncludeBody(item.CategoryId)"><span class="label-reportoption"
            >Include in Report Body</span>
          </mat-checkbox>
        </b>
      </span>
    </div>

      <div style="margin-top: 11px;">
        <span class="component-flag">
          <b>
            <!-- <mat-checkbox style="padding-right: 8px;"  [checked]="item?.IncludeDataTable" (change)="toggleIncludeTable(item.QuestionCatId)"><span class="label-reportoption"
              >Include Data Table</span>
            </mat-checkbox> -->
            <mat-checkbox style="padding-right: 8px;"   [checked]="item?.IncludeInReport" (change)="toggleIncludeTable(item.CategoryId)"><span class="label-reportoption"
              >Include Data Table</span>
            </mat-checkbox>
          </b>
        </span>
      </div>

  
  </div>

</div>
          
        
        </li>
      </div>
      

     

    </ul>

  </mat-card>

</div>